export default function SkillCard({ logo, title }) {
  return (
    <div className="flex items-center justify-center gap-4 rounded-lg bg-portfolio-page px-3 py-2.5 [&_svg]:h-[36px] [&_svg]:w-[36px] [&>div]:flex [&>div]:flex-col [&>div]:items-center [&>div]:gap-2">
      {logo}
      <div>
        <p className="whitespace-nowrap text-xs font-medium capitalize">{title}</p>
      </div>
    </div>
  );
}
